import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {Field} from "../form/Field";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {IWindow} from "../../index";
import {LineChart} from "../charts/LineChart";
import {DoughnutChat} from "../charts/DoughnutChat";
import {Col, Row, Container} from "reactstrap";

const IWindow: IWindow = (window as IWindow);

export class AdminDashboardFormData {
    @observable election_id = null;
	@observable state_id: number | null = null;
	    @observable code = '';
    @observable name = '';
    @observable station_number = '';
    @observable is_active = true;
    @observable local_government_area_id: number | null = null;
    @observable ward_id: number | null = null;
    @observable register_voters: number | null = null;
	
	@observable senatorial_district_id = null;
    @observable federal_constituency_id = null;
    @observable state_constituency_id = null;
    @observable is_filter_on_region = 1;
}

export class AdminDashboardForm extends CrudForm {
    modelName = 'AdminDashboard';
    showSubmitButton = false;
    @observable interval:string = "3";
    @observable electionSubscription = {
        election_polling_unit: 0,
        election_polling_unit_subscriptions: 0,
        election_unsubscribed_polling_unit: 0,
    };

    @observable subscription = null;
	@observable isLoaded = false;

    @observable regionCount = {
        federal_constituencies: 0,
        local_government_areas: 0,
        senatorial_districts: 0,
        state_constituencies: 0,
        states: 0,
        wards: 0,
        polling_units: 0,
		inecRegVoters: 0,
    };

    loadMoreData(props: any, module: any) {
         this.onLoadRegionCount();
        this.onLoadSubscription();
    }

    onLoadRegionCount = () => {
		this.isLoaded = false;
        api.dashboard.getRegionCountAction({
            election_id: this.formStore.getValue('election_id'),
			state_id: this.formStore.getValue('state_id'),
			senatorial_district_id: this.formStore.getValue('senatorial_district_id'),
			federal_constituency_id: this.formStore.getValue('federal_constituency_id'),
			local_government_area_id: this.formStore.getValue('local_government_area_id'),
			state_constituency_id: this.formStore.getValue('state_constituency_id'),
			ward_id: this.formStore.getValue('ward_id'),
        }).then((data: any) => {
			this.isLoaded = true;
            this.regionCount = data;
        });
    };

    onLoadSubscription = () => {
        api.dashboard.getSubscriptionAction({
             filter: {
                interval: this.interval
             }
        }).then((data: any) => {
            this.subscription = data.subscriptions;
        });
    };

    onChangeElection = () => {
        this.formStore.getValue('election_id') && api.dashboard.getElectionSubscribedPollingUnitAction({
            election_id: this.formStore.getValue('election_id'),
        }).then((data: any) => {
            this.electionSubscription = data;
        });
		// this.onLoadRegionCount();
    };

    onChangeInterval = (interval:any) => {
        this.interval = interval;
        this.onLoadSubscription();
    };

    onLoadElections = () => {
        return api.election.getListAction().then((data:any) => {
            if(data && data.length){
                this.formStore.setValue('election_id', data[0].id);
                this.onChangeElection();
            }
            return data;
        });
    };
	
	 senatorialDistrictDropDown() {
        return <Col md={2}>
            <Field
                key={'senatorial_district_id_' +
                    this.formStore.getValue('state_id') 
                }
                name="senatorial_district_id"
                placeholder="Select Senatorial Districts"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.senatorialDistrict.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                    this.formStore.setValue('federal_constituency_id', null);
					
					
					this.onLoadRegionCount();
                }}
            />
        </Col>;
    }

    federalConstituencyDropDown() {
        return <Col md={2}>
            <Field
                key={'federal_constituency_id_' +
                this.formStore.getValue('state_id')
                }
                name="federal_constituency_id"
                placeholder="Select Federal Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.federalConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                    this.formStore.setValue('senatorial_district_id', null);
					
					
					this.onLoadRegionCount(); 
                }}
            />
        </Col>;
    }

    stateConstituencyDropDown() {
        return <Col md={2}>
            <Field
                key={'state_constituency_id_' +
                    this.formStore.getValue('state_id')
                }
                name="state_constituency_id"
                placeholder="Select State Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.stateConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
					this.onLoadRegionCount();
                }}
            />
        </Col>;
    }


    renderFields() {
        return ( 
            <>
				<div className="row">
					<div className="col-xl-6 mt-4 mt-xl-0 d-flex flex-column" >&nbsp;</div>
					<div className="col-xl-6 mt-4 mt-xl-0 d-flex flex-column" >
								<div className="ml-auto col-md-5">
                                    <Field
                                        key="dashboard-election"
                                        name="election_id"
                                        placeholder="Select Election..."
                                        component={Select}
                                        loadOptions={this.onLoadElections}
                                        store={this.formStore}
                                        required={true}
                                        onChange={this.onChangeElection}	
                                    />
                                </div>
					</div>			
				
				
				</div>
                <div className="row">
                    <div className="col-xl-6 mt-4 mt-xl-0 d-flex flex-column"
                         key={'subscription-election-list'}>
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-bar-chart mr-2"></span>
                                <h6>Election Monitoring</h6>
                                
                            </div>
                            <div className="card-body">
                                {
                                    this.formStore.getValue('election_id') ?
                                        <DoughnutChat
                                            id="polling-unit-chart"
                                            key={'polling-unit-subcripbtion-chart'}
                                            title="Polling Units"
                                            backgroundColor={[
                                                'rgb(197,44,3)',
                                                'rgb(41,138,61)',
                                            ]}
                                            backgroundHoverColor={[
                                                'rgba(197,44,3, 0.8)',
                                                'rgba(41,138,61, 0.78)',
                                            ]}
                                            legend={{
                                                display: true
                                            }}
                                            data={[
                                                {
                                                    label: 'Unmonitored',
                                                    value: this.electionSubscription.election_unsubscribed_polling_unit,
                                                },
                                                {
                                                    label: 'Monitored',
                                                    value: this.electionSubscription.election_polling_unit_subscriptions,
                                                }
                                            ]}
                                        /> : ''
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 mt-4 mt-xl-0 d-flex flex-column"
                         key={'subscription-candidates' + this.formStore.getValue('election_id')}>
                        <div className="card dashboard-card box-shadow border-0 rounded-0 flex-grow-1">
                            <div className="card-header d-flex align-items-center">
                                <span className="icon-bar-chart mr-2"></span>
                                <h6>Subscriptions</h6>
                                <div className="ml-auto btn-group mr-2" role="group" aria-label="Basic example">
                                    <button type="button" className={"btn "+ (this.interval == "3" ? 'btn-primary' : ' btn-secondary')} onClick={ () => this.onChangeInterval(3)}>3 Months</button>
                                    <button type="button" className={"btn "+ (this.interval == "6"  ? 'btn-primary' : ' btn-secondary')} onClick={ () =>this.onChangeInterval(6)}>6 Months</button>
                                    <button type="button" className={"btn "+ (this.interval == "12"  ? 'btn-primary' : ' btn-secondary')} onClick={ () => this.onChangeInterval(12)}>1 Year</button>
                                </div>
                            </div>
                            <div className="card-body">
                                {
                                    this.interval && this.subscription ?

                                        <LineChart
                                            id="subscription-party-chart"
                                            key={'subscription-party-chart'}
                                            title="Election Subscriptions"
                                            data={this.subscription}
                                        />
                                        : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
				
				
				
				{
					<Container>
				
					<Row className="form-row">&nbsp;</Row>
				
					<Row className="form-row">
						<Col md={2}>
							<Field
								name="state_id"
								placeholder="Select State"
								component={Select}
								loadOptions={api.state.getListAction}
								store={this.formStore}
								onChange={() => {
									this.formStore.setValue('local_government_area_id', null);
									this.formStore.setValue('ward_id', null);
									this.formStore.setValue('senatorial_district_id', null);
									this.formStore.setValue('federal_constituency_id', null);
									this.formStore.setValue('state_constituency_id', null);
									
									this.onLoadRegionCount();
									
								}}
							/>
						</Col>
					
					
					
					{this.senatorialDistrictDropDown()}
                {this.federalConstituencyDropDown()}

                <Col md={2}>
                    <Field
                        key={'filter-lga-' +
                        this.formStore.getValue('state_id') +
                        this.formStore.getValue('senatorial_district_id') +
                        this.formStore.getValue('federal_constituency_id')
                        }
                        name="local_government_area_id"
                        placeholder="Select LGA"
                        component={Select}
                        loadOptions={() => {
                            return api.localGovernmentArea.getListAction({
                                filters: {
                                    state_id: this.formStore.getValue('state_id'),
                                    senatorial_district_id: this.formStore.getValue('federal_constituency_id') ? null :
                                        this.formStore.getValue('senatorial_district_id'),
                                    federal_constituency_id: this.formStore.getValue('federal_constituency_id'),
                                }
                            });
                        }}
                        store={this.formStore}
                        onChange={() => {
                            this.formStore.setValue('ward_id', null);
							this.onLoadRegionCount();
                        }}
                    />
                </Col>

                {this.stateConstituencyDropDown()}

                <Col md={2}>
                    <Field
                        key={"ward_id_" +
                            this.formStore.getValue('local_government_area_id') +
                            this.formStore.getValue('state_id') +
                            this.formStore.getValue('state_constituency_id')
                        }
                        name="ward_id"
                        placeholder="Select Ward"
                        component={Select}
                        loadOptions={() => {
                            return api.ward.getListAction({
                                filters: {
                                    state_id: this.formStore.getValue('state_id'),
                                    state_constituency_id: this.formStore.getValue('state_constituency_id'),
                                    local_government_area_id: this.formStore.getValue('state_constituency_id') ? null :
                                        this.formStore.getValue('local_government_area_id'),
                                }
                            });
                        }}
                        store={this.formStore}
						onChange={() => {
                            
							this.onLoadRegionCount();
                        }}
                    />
                </Col>
					
					
					
					
					
					
					
					
					</Row>	
					
					
					
					
					
					</Container>
				
				}
				
				
				
				
				
				
				

                <div className="row py-2" key={'subscription-region' + this.formStore.getValue('election_id')}>
                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">States</div>
                            <div className="stat-value">{this.isLoaded ? this.regionCount.states : 'Loading ...' }</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Senatorial Districts</div>
                            <div className="stat-value">{this.isLoaded ? this.regionCount.senatorial_districts : 'Loading ...' }
							</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Local Government Areas</div>
                            <div className="stat-value">
							{this.isLoaded ? this.regionCount.local_government_areas : 'Loading ...' }
							</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Wards</div>
                            <div className="stat-value">
							{this.isLoaded ? this.regionCount.wards : 'Loading ...' }
							</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Polling Units</div>
                            <div
                                className="stat-value">
								{this.isLoaded ? this.regionCount.polling_units : 'Loading ...' }
								</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">Federal Constituencies</div>
                            <div className="stat-value">
							{this.isLoaded ? this.regionCount.federal_constituencies : 'Loading ...' }
							</div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">State Constituencies</div>
                            <div className="stat-value">
							{this.isLoaded ? this.regionCount.state_constituencies : 'Loading ...' }
							</div>
                        </div>
                    </div>
					
					
					 <div className="col-sm-6 col-xl-3 d-flex flex-column mt-3">
                        <div className="card stat-card box-shadow border-0 rounded-0 text-center">
                            <div className="stat-label">INEC REG. VOTERS</div>
                            <div className="stat-value">
							{this.isLoaded ? this.regionCount.inecRegVoters : 'Loading ...' }
							</div>
                        </div>
                    </div>
					
					
                </div>

            </>
        );
    }
}

export class AdminDashboardPage extends React.Component {
    modelName = 'AdminDashboard';

    render() {
        return (
            <>
                <AdminDashboardForm
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/AdminDashboardPage.tsx